// Vendors
import { TrackingUserStatusEnum, TrackingUserTypeEnum } from '@openbank/ziniaweb-ui-core-models';

const TRACKING_CONFIGURATION = {
  userId: '',
  userType: TrackingUserTypeEnum.PROSPECT,
  userStatus: TrackingUserStatusEnum.LOGGEDIN,
};

export { TRACKING_CONFIGURATION };
